<template>
  <picture class="contents">
    <source :srcset="webpSrc" type="image/webp" />
    <img
      :src="src"
      :alt="alt"
      :width="width"
      :height="height"
      :class="className"
      v-bind="restAttrs"
    />
  </picture>
</template>

<script setup lang="ts">
defineOptions({ inheritAttrs: false })

const props = defineProps<{
  src: string
  alt: string
  width?: number
  height?: number
}>()

const attrs = useAttrs()
const { class: className, ...restAttrs } = attrs as { class?: string } & Record<string, unknown>

const webpSrc = computed(() =>
  props.src.replace(/\.(jpe?g|png)$/i, '.webp')
)
</script>